import { Typography } from "@mui/material";

/**
 *
 * @returns {ReactElement} Timer page
 */
export function Timer() {
  return <Typography>Happy Coding!</Typography>;
}
